import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { format, setHours, setMinutes, setSeconds } from 'date-fns';

const AutocompleteIssueTimestampHours = ({ handleTimeSelect }) => {
  const [issueTimeOptionsHours, setIssueTimeOptionsHours] = useState([]);
  const [defaultIssueTimeHours, setDefaultIssueTimeHours] = useState(null);

  useEffect(() => {
    // Configurar las horas fijas requeridas
    // const times = [1, 7, 13, 19].map(hour => {
    const times = [1, 7, 13, 19].map(hour => {
      const time = setHours(setMinutes(setSeconds(new Date(), 0), 0), hour);
      return {
        label: `${format(time, 'HH:mm')} UTC`, // Mostrar la hora con la etiqueta UTC
        value: format(time, 'HH:mm:ss') // Valor completo para el control
      };
    });

    setIssueTimeOptionsHours(times);

    // Seleccionar la primera opción como predeterminada
    if (times.length > 0 && !defaultIssueTimeHours) {
      setDefaultIssueTimeHours(times[0]);
      handleTimeSelect(times[0].value); // Llamar a handleTimeSelect con la hora predeterminada
    }
  }, [handleTimeSelect, defaultIssueTimeHours]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
      <Autocomplete
        options={issueTimeOptionsHours}
        value={defaultIssueTimeHours}
        onChange={(event, newValue) => {
          setDefaultIssueTimeHours(newValue);
          handleTimeSelect(newValue.value); // Llamar a handleTimeSelect con la hora seleccionada
        }}
        getOptionLabel={(option) => option.label}
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            label="Issue Time"
            variant="outlined"
            sx={{
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
              '.MuiInputBase-input': {
                padding: '10px',
                color: '#333',
                userSelect: 'none',
                pointerEvents: 'none',
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#115293',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
            }}
          />
        )}
        sx={{
          width: 140,
          '.MuiAutocomplete-endAdornment': {
            '.MuiSvgIcon-root': {
              color: '#1976d2',
            },
          },
        }}
      />
    </Box>
  );
};

export default AutocompleteIssueTimestampHours;
